import React from 'react';
import PageBanner from '../../components/PageBanner/PageBanner';
import './DisclaimerPage.css';

const DisclaimerPage: React.FC = () => {
    return (
        <div className="page-container">
            <PageBanner
                title="Disclaimer"
                subtitle="Important legal information regarding the use of this website"
                breadcrumbs={[
                    { label: 'Home', path: '/' },
                    { label: 'Disclaimer', path: '/disclaimer' }
                ]}
            />

            <div className="container section">
                <div className="legal-content">
                    <h3>User Acknowledgement</h3>
                    <p>
                        By accessing this website <a href="www.srskannan.com">www.srskannan.com</a>, you acknowledge and confirm that you are seeking information relating to Advocate Kannan of your own accord and that there has been no form of solicitation, advertisement, or inducement by Advocate Kannan or its members.
                    </p>

                    <h3>No Legal Advice</h3>
                    <p>
                        The content of this website is for informational purposes only and should not be interpreted as soliciting or advertisement. No material/information provided on this website should be construed as legal advice. Advocate Kannan shall not be liable for consequences of any action taken by relying on the material/information provided on this website.
                    </p>

                    <h3>No Lawyer-Client Relationship</h3>
                    <p>
                        The transmission, receipt or use of this site would not create any lawyer-client relationship. In cases where the user has any legal issues, he/she in all cases must seek independent legal advice.
                    </p>
                </div>
            </div>
        </div>
    );
};

export default DisclaimerPage;
